// This file is automatically generated by AutoIndexPlugin. Do not edit manually.
import './app';
import './beta-warning';
import './files';
import './flash-messages';
import './header-bg';
import './main';
import './navigation';
import './prize-variant';
import './read-smore';
import './receipt';
import './sliders/products';
import './winners';
